import type { Event } from "@sentry/react";

/**
 * ZXing 0.23 logs a console warning for every reader that finds no code on a camera frame, because its
 * NotFoundException, FormatException and ChecksumException no longer extend ReaderException.
 * Remove this filter when https://github.com/zxing-js/library/issues/648 is fixed.
 */
export function isZxingReaderWarning(event: Event): boolean {
	const consoleArguments = event.extra?.arguments;
	return (
		event.logger === "console" &&
		Array.isArray(consoleArguments) &&
		consoleArguments[0] === "MultiFormatReader: non-ReaderException from reader:"
	);
}
